import React from 'react';
import { connect } from 'react-redux'
import { Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faArrowDown, faTimes } from '@fortawesome/free-solid-svg-icons'
import { removeItem, addQuantity, substractQuantity } from '../actions/cartAction'


class CarTable extends React.Component {
    imageUrl(image) {
        return (this.props.images.find(x => x.name === image) || {}).url || ''
    }

    render() {
        let total = 0
        return (
            <div className="cart-table">

            <h4>quý khách đã chọn</h4>
            <Table className="cart-array" responsive>
                <thead>
                    <tr>
                        <th className="cart-picture"></th>
                        <th className="cart-product">Sản Phẩm</th>
                        <th className="cart-item">Quy cách đóng gói</th>
                        <th className="cart-quantity">Số lượng</th>
                        <th className="cart-price">Đơn giá</th>
                        {this.props.readOnly ? [] :(<th className="cart-remove"></th>)}
                    </tr>
                </thead>
                <tbody>{
                    this.props.items.filter(item => !this.props.readOnly || item.quantity)
                    .map(item => {
                        let product = this.props.products[item.product]
                        let pitem = product.items.find(p => p.id === item.item)
                        total += item.quantity * pitem.price
                        return (<tr key={item.product + '-' + item.item}
                            className={item.quantity ? '' : 'empty'}
                        >
                            <td className="cart-picture">
                                <img src={this.imageUrl(product.picture)} />
                            </td>
                            <td className="cart-product">{product.name}</td>
                            <td className="cart-item">{pitem.size}</td>
                            <td className="cart-quantity">
                                {item.quantity}
                                {this.props.readOnly ? [] : (<div className="plus-minus">
                                    <span onClick={() => this.props.addQuantity(item.product, item.item)}>
                                        <FontAwesomeIcon icon={faArrowUp} />
                                    </span>
                                    <span onClick={() => this.props.substractQuantity(item.product, item.item)}>
                                        <FontAwesomeIcon icon={faArrowDown} />
                                    </span>
                                </div>)}
                            </td>
                            <td className="cart-price">{pitem.price}000 VND</td>
                            {this.props.readOnly ? [] : (<td className="cart-remove" >
                                <span onClick={() => this.props.removeItem(item.product, item.item)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </span>
                            </td>)}
                        </tr>)
                    })
                }</tbody>
                <tfoot>
                    <tr>
                        <th className="cart-picture"></th>
                        <th className="cart-product" colSpan="2">Tổng tiền</th>
                        <th className="cart-quantity"></th>
                        <th className="cart-price">{total}000 VND</th>
                        <th className="cart-remove"></th>
                    </tr>
                </tfoot>
            </Table>
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
        products: state.products,
        items: state.items,
        images: state.images,
    }
} 

const mapDispatchToProps = (dispatch) => {
    return {
        removeItem() { dispatch(removeItem(...arguments))},
        addQuantity() { dispatch(addQuantity(...arguments))},
        substractQuantity() { dispatch(substractQuantity(...arguments))}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarTable)